import { inject, Injectable } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { ConsoleLogger, HttpService, Query, TaggedUrl, Tags } from '@skylab-shared/core';
import { EInvoiceCreationValidationCode, EInvoiceCreationValidationErrorCode } from '@skylab-shared/dataModel';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface EInvoiceReceivedHeaderValidationResultQueryParams {
    id: number;
}

interface EInvoiceReceivedHeaderValidationResultQueryInternalResult {
    kind: KsefDocumentHeaderLogKind;
    payload: string;
}

export enum KsefDocumentHeaderLogKind {
    Unknown = 'Unknown',
    ValidationResult = 'ValidationResult',
    ProcessingError = 'ProcessingError',
    ProcessingSuccess = 'ProcessingSuccess'
}

export type EInvoiceCreationValidationError = {
    Code: EInvoiceCreationValidationErrorCode.UnsupportedSchema;
} | {
    Code: EInvoiceCreationValidationErrorCode.UnsupportedDocumentKind;
    Data: {
        kind: string;
    }
} | {
    Code: EInvoiceCreationValidationErrorCode.NoCurrencyInDictionary;
    Data: {
        currencyCode: string;
    }
} | {
    Code: EInvoiceCreationValidationErrorCode.NoCurrencyExchangeRate;
} | {
    Code: EInvoiceCreationValidationErrorCode.DifferentExchangeRates;
} | {
    Code: EInvoiceCreationValidationErrorCode.InvalidSellerCountryCode;
    Data: {
        countryCode: string
    }
} | {
    Code: EInvoiceCreationValidationErrorCode.UnsupportedCommunityTransaction
} | {
    Code: EInvoiceCreationValidationErrorCode.InvoiceOSS
} | {
    Code: EInvoiceCreationValidationErrorCode.UnsupportedVatRates;
    Data: {
        tStawkaPodatku: string
    }
};


export type EInvoiceReceivedHeaderValidationItem = {
    kind: KsefDocumentHeaderLogKind;
} & ({
    Code: EInvoiceCreationValidationCode.InvalidXml;
    Errors: EInvoiceCreationValidationError[]
} | {
    Code: EInvoiceCreationValidationCode.DocumentAlreadyExists | EInvoiceCreationValidationCode.DocumentHeaderNotFound | EInvoiceCreationValidationCode.NoXmlYet | EInvoiceCreationValidationCode.XmlNotFound | EInvoiceCreationValidationCode.Unexpected;
});

export class EInvoiceReceivedHeaderValidationResultQuery extends Query<EInvoiceReceivedHeaderValidationItem> {
    public constructor(public readonly params: EInvoiceReceivedHeaderValidationResultQueryParams) {
        super();
    }
}
@Injectable({ providedIn: 'root'})
@QueryHandlerFor(EInvoiceReceivedHeaderValidationResultQuery)
export class EInvoiceReceivedHeaderValidationResultQueryHandler {
    #Url = TaggedUrl.join('eInvoices/headers/:id/lastValidation', [Tags.Api]);
    #logger = new ConsoleLogger(this.constructor.name);
    #http = inject(Http) as HttpService;

    public async handleAsync(query: EInvoiceReceivedHeaderValidationResultQuery): Promise<EInvoiceReceivedHeaderValidationItem> {
        const url = fillPlaceholders(this.#Url, { id: query.params.id });

        const { data } = await this.#http.get<EInvoiceReceivedHeaderValidationResultQueryInternalResult>(url);
        let parsed = {};

        try {
            parsed = JSON.parse(data.payload);
        } catch (err) {
            this.#logger.error(err);
        }

        return <EInvoiceReceivedHeaderValidationItem>{
            ...parsed,
            kind: data.kind
        };
    }
}
